import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'CurriculumPage',
};

import { useStore, useContext, onMounted, useRoute, computed } from '@nuxtjs/composition-api';
import ExpandableDescription from '@/components/category/ExpandableDescription.vue';
import CategoryNav from '@/components/category/CategoryNav.vue';
import ResourcesList from '@/components/resource/ResourcesList.vue';
import { Curriculum } from '@/types/Curriculum';
import { State } from '@/store';

interface Props {
  resourceParams: Record<string, unknown>;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    resourceParams: { default: () => ({}) }
  },
  setup(__props: any) {

const store = useStore<State>();
const { $mzAnalyticsApi } = useContext();
const $route = useRoute();



const availableFilters = computed((): string[] => {
  if ($route.value.name?.match(/curriculum-v9/)) {
    return [
      'types',
      'year_levels',
      'curriculum',
      'resource_types',
      'availability',
      'file_formats',
      'publishers',
    ];
  } else {
    return ['types', 'resource_types', 'availability', 'file_formats', 'publishers'];
  }
});

const curriculum = computed<Curriculum>(() => store.getters.curriculum);

onMounted(() => {
  if (curriculum.value.event_params) {
    $mzAnalyticsApi({
      event: 'pageView',
    });
  }
});

return { __sfc: true,store, $mzAnalyticsApi, $route, availableFilters, curriculum, ExpandableDescription, CategoryNav, ResourcesList }
}

})